module.exports = {
      id: "rocket-usage",
      viewBox: "0 0 62 45",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#rocket",
      toString: function () {
        return this.url;
      }
    }